import { render } from "./SmsManagement.vue?vue&type=template&id=04694275&scoped=true"
import script from "./SmsManagement.vue?vue&type=script&lang=js"
export * from "./SmsManagement.vue?vue&type=script&lang=js"

import "./SmsManagement.vue?vue&type=style&index=0&id=04694275&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04694275"]])

export default __exports__